<div class="container">
  <div style="margin: 2em 0">
    <div class="header-text">Produktbilder*</div>
  </div>
  <div class="row mediaAlignment">
    <ng-container *ngFor="let media of mediaList; let idx = index">
      <ng-container *ngIf="isImage(media)">
        <div class="tile" [ngClass]="isCoverImage(media) ? 'selected' : 'not-selected'">
          <div class="top-row" [ngClass]="isCoverImage(media) ? 'selected' : 'not-selected'">
            <markant-icon *ngIf="mediaList[0] != media" src="assets/svg/chevron-left--dense.svg" class="navIcon top-left nav-button" (click)="up(media, idx)">
              <markant-tooltip [label]="'Nach links verschieben'" placement="top" trigger="mouseenter focus" colorScheme="secondary"></markant-tooltip>
            </markant-icon>

            <div *ngIf="mediaList[0] == media" class="top-left"></div>
            <div class="cover-image-selector top-mid" [ngClass]="isCoverImage(media) ? 'selected' : 'not-selected'" (click)="selectCover(media)">
              {{ isCoverImage(media) ? 'Hauptbild bearbeiten' : 'Als Hauptbild festlegen' }}
            </div>
            <div *ngIf="mediaList[mediaList.length - 1] == media" class="top-right"></div>

            <markant-icon
              *ngIf="mediaList[mediaList.length - 1] != media"
              src="assets/svg/chevron-right--dense.svg"
              class="navIcon top-right nav-button"
              (click)="down(media, idx)"
            >
              <markant-tooltip [label]="'Nach rechts verschieben'" placement="top" trigger="mouseenter focus" colorScheme="secondary"></markant-tooltip>
            </markant-icon>
          </div>
          <div class="image-box-tumbnail" style="position: relative">
            <img class="bounded-thumbnail" (click)="openModal(media.uri)" [src]="media.uri" alt="" />
            <div class="bottom-right navButton">
              <markant-icon
                *ngIf="!isCoverImage(media)"
                src="assets/svg/m_trash.svg"
                (click)="remove(media, idx)"
                class="button-delete"
                [ngClass]="isCoverImage(media) ? 'selected' : 'not-selected'"
                alt=""
              ></markant-icon>
              <markant-icon
                *ngIf="isCoverImage(media)"
                src="assets/svg/m_trash.svg"
                class="button-delete"
                [ngClass]="isCoverImage(media) ? 'selected' : 'not-selected'"
                alt=""
              ></markant-icon>
              <markant-tooltip
                [label]="isCoverImage(media) ? deleteTextSelected : deleteTextNotSelected"
                placement="top"
                trigger="mouseenter focus"
                colorScheme="secondary"
              ></markant-tooltip>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="tile">
      <div class="newUpload" style="margin: -6% -5% 0% -4%">
        <app-continuous-action style="position: absolute" [sticky]="false"></app-continuous-action>
        <app-dropzone
          [message]="'Hier kannst Du Deine Bilder hochladen'"
          accept=".png, .jpeg, .jpg"
          [maxFileSize]="maxImageSize"
          (fileListChange)="handleNewFiles($event)"
          [disabled]="disabled"
        ></app-dropzone>
      </div>
    </div>
  </div>
</div>
<app-upload-image
  *ngIf="this.selectedCoverImage != undefined"
  [imageType]="imageType"
  [height]="300"
  [width]="300"
  [imageURL]="this.selectedCoverImage.uri"
  [originUUID]="this.selectedCoverImage.uuid"
  [allowNewUpload]="false"
  [startupName]="startupName"
  [productName]="productName"
  [productCategory]="productCategory"
  (newFileEvent)="this.updateCoverImage($event)"
  (cancelEvent)="this.cancelUpload()"
></app-upload-image>

<markant-dialog
  *ngIf="this.dialogState"
  class="markant-modal"
  style="text-align: center; width: 600px; height: 400px"
  fullwidth="false"
  critical="true"
  [open]="true"
>
  <div class="markant-dialog">
    <div class="markant-dialog-header">
      <div></div>
      <div class="navWrapper">
        <markant-icon src="./assets/svg/chevron-left--dense.svg" class="slideButton navButton" (click)="before()"> Vorheriges </markant-icon>
        <markant-icon src="./assets/svg/chevron-right--dense.svg" class="slideButton navButton" (click)="next()"> Nächstes </markant-icon>
      </div>
      <div class="closeWrapper">
        <markant-icon src="./assets/svg/close--dense.svg" class="closeButton navButton" (click)="closeModal()"> Schließen </markant-icon>
      </div>
    </div>
    <div class="markant-dialog-content">
      <div class="imageWrapper">
        <img [src]="this.pickedImage" alt="" class="d-block bigImage" />
      </div>
      <div class="markant-dialog-footer"></div>
    </div>
  </div>
</markant-dialog>
